import React from "react";
import SampleImage from "../../assets/iris-large.svg";
import Picture1 from "../../assets/Picture1.png";
import Picture2 from "../../assets/Picture2.png";
import Picture3 from "../../assets/Picture3.png";
import Picture4 from "../../assets/Picture4.png";
import Picture5 from "../../assets/Picture5.png";
import Picture6 from "../../assets/Picture6.png";
import Picture11 from "../../assets/Picture11.PNG";
import Picture12 from "../../assets/Picture12.jpg";
import { useTranslation } from "react-i18next";

function UKMeetOutTeam() {
  const { t, i18n } = useTranslation();
  return (
    <div className="my-5">
      <div className="container-xxl px-0 px-md-3 pt-2 pt-lg-0">
        {/* section 2 */}
        <div className="pgs-title mt-5 my-3 px-3 px-lg-0">
          <h1>
            <span className="pgs-title">MEET OUR </span>
            <span className="pgs-title__v">TEAM</span>
          </h1>
        </div>
        <div className="row justify-content-center">
          <div className="col-11 col-lg-12">
            <div className="pgs-heading fw-bold textc-primary my-2">
              Scientific Advisory Board
            </div>
            <div className="pgs-text my-2">
              Our global team leads the charge in scientifically and clinically
              validated nutrigenomics. This dynamic consortium includes
              certified functional medicine doctors, scientists, and genomics
              experts across the U.S., Canada, Europe, and Australia. Together,
              they work to support PureGenomics<sup>&reg;</sup> by integrating
              the latest in research and clinical applications into reports and
              recommendations so that you don’t have to. Please take a moment to
              meet our trusted team.
            </div>
          </div>
        </div>
        <br />
        {/* section 3 */}

        <div className="my-3">
          {/* p1 */}
          <div className="row my-3 justify-content-center justify-content-lg-around">
            <div className="col-11 col-lg-5 my-4">
              <div>
                <img src={Picture1} alt="Kelly C" className="meet-img my-3" />
              </div>
              <div className="pgs-heading__sub ff-m textc-primary fw-bold">
                Kelly C. Heim, Ph.D.* (Co-Chair)
              </div>
              <div className="pgs-text">
                Co-creator of{" "}
                <span className="textc-primary fw-normal">PureGenomics<sup>&reg;</sup></span>
                , he oversees the evidence-based development of
                the platform and its educational resources. As a pharmacologist
                specializing in natural products, Dr. Heim is a published author
                and illustrator of various studies, scholarly reviews, and book
                chapters.
              </div>
            </div>
            <div className="col-11 col-lg-5 my-4">
              <div>
                <img
                  src={Picture2}
                  alt="Barry Ritz"
                  className="meet-img my-3"
                />
              </div>
              <div className="pgs-heading__sub ff-m textc-primary fw-bold">
                Barry Ritz, Ph.D.** (Co-Chair)
              </div>
              <div className="pgs-text">
                Dr. Ritz is a member of the American Society for Nutritional
                Sciences and executive board of the Council for Responsible
                Nutrition’s Medical Affairs Subcommittee. A former professor at
                Drexel University, Dr. Ritz is an expert in nutritional
                immunology and has numerous publications in scientific journals.
              </div>
            </div>

            <div className="col-11 col-lg-5 my-4">
              <div>
                <img
                  src={Picture3}
                  alt="Nathan Morris"
                  className="meet-img my-3"
                />
              </div>
              <div className="pgs-heading__sub ff-m textc-primary fw-bold">
                Nathan Morris, M.D.+
              </div>
              <div className="pgs-text">
                Co-creator of{" "}
                <span className="textc-primary fw-normal">PureGenomics<sup>&reg;</sup></span>
                , functional medicine provider with over a
                decade of experience and founder of Good Medicine, a
                multidisciplinary functional medicine practice in Monument, CO.
              </div>
            </div>
            <div className="col-11 col-lg-5 my-4">
              <div>
                <img
                  src={Picture4}
                  alt="Penny Kendall-Reed"
                  className="meet-img my-3"
                />
              </div>
              <div className="pgs-heading__sub ff-m textc-primary fw-bold">
                Penny Kendall-Reed, N.D.+
              </div>
              <div className="pgs-text">
                Naturopath and director of natural therapies at the Urban
                Wellness Clinic in Toronto. Dr. Kendall-Reed travels worldwide
                lecturing on genetics, neuroendocrine disorders, and
                metabolic-related diseases and is the creator of the integrated
                genetic platform GeneRx.ca.
              </div>
            </div>

            <div className="col-11 col-lg-5 my-4">
              <div>
                <img
                  src={Picture5}
                  alt="Denise Furness"
                  className="meet-img my-3"
                />
              </div>
              <div className="pgs-heading__sub ff-m textc-primary fw-bold">
                Denise Furness, Ph.D.+
              </div>
              <div className="pgs-text">
                Geneticist, registered nutritionist, and founder of Your Genes
                and Nutrition, applying her knowledge in private practice
                working alongside some of Australia’s most prominent integrative
                Medical Doctors. She is also a pioneer in the field of
                nutrigenomics and personalised medicine with over 15 years of
                experience in the area.
              </div>
            </div>
            <div className="col-11 col-lg-5 my-4">
            </div>
          </div>
          <div className="col-11  mx-auto">
            <div
              className="pgs-text fw-bold text-grey"
              style={{ color: "rgb(145 145 145)" }}
            >
              + is a retained advisor for Pure Encapsulations
            </div>
            <div
              className="pgs-text fw-bold text-grey"
              style={{ color: "rgb(145 145 145)" }}
            >
              * is an employee of Atrium innovations
            </div>
            <div
              className="pgs-text fw-bold text-grey"
              style={{ color: "rgb(145 145 145)" }}
            >
              ** is an employee of Nestle Health Science
            </div>
          </div>
        </div>
        <br />
        {/* section 4 */}
        <div className="row justify-content-center my-4">
          <div className="col-11 col-lg-12">
            <div className="pgs-heading pgs-heading fw-bold textc-primary my-2">
              Client Support Team
            </div>
            <div className="pgs-text my-2">
              Nutritionists experienced with integrating PureGenomics into your practice are ready to support you. Whether your questions are related to account setup, troubleshooting, or reading a report, we’ve got that covered.
            </div>
          </div>
        </div>
        {/* section 5 */}
        <div className=" my-3">
          {/* p6 */}
          <div className="row my-3 justify-content-center justify-content-lg-around">
            <div className="col-11 col-lg-5 my-4 my-lg-0">
              <div>
                <img src={Picture11} alt="Joanna Dziedzic" className="meet-img my-3" />
              </div>
              <div className="pgs-heading__sub ff-m textc-primary fw-bold">
                Joanna Dziedzic, Nutritional Therapist
              </div>
              <div className="pgs-text">
                Nutritionist providing technical and customer support for all PureGenomics phone and email inquiries. Have a question about where to start, how to navigate a patient report, setting up patients, uploading data, or troubleshooting? Joanna is here to assist you.
              </div>
              <br />
              <div className="pgs-text">
                <b> United Kingdom Contact Info:</b> <br />
                Joanna Dziedzic <br />
                P. +447494 876576 <br />
                E.{" "}
                <a href="mailto: joanna@pure-encapsulations.uk">
                  joanna@pure-encapsulations.uk
                </a>
              </div>
            </div>
            <div className="col-11 col-lg-5 my-4 my-lg-0">
            </div>
          </div>
          <br />
        </div>
      </div >
    </div >
  );
}

export default UKMeetOutTeam;
